"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ActionTypes_1 = require("../ActionTypes");
var initialState = {
    current: null,
    summary: null,
    conflict: null,
    activecodes: [],
    shortcode: undefined
};
function default_1(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes_1.UPDATE_BUILD_SESSION: {
            return __assign(__assign({}, state), { current: action.data, activecodes: action.activecodes, summary: action.summary });
        }
        case ActionTypes_1.ON_CONFLICT: {
            return __assign(__assign({}, state), { conflict: action.data });
        }
        case ActionTypes_1.CLEAR_CONFLICT: {
            return __assign(__assign({}, state), { conflict: null });
        }
        case ActionTypes_1.ON_SHORT_CODE: {
            return __assign(__assign({}, state), { shortcode: action.data });
        }
        default: {
            return state;
        }
    }
}
exports.default = default_1;
//# sourceMappingURL=BuildSession.js.map